import React from "react";

const Backend = () => {
	return (
		<div className="skills_content">
			<h3 className="skills_title">Backend</h3>

			<div className="skills_box">
				<div className="skills_group">
					<div className="skills_data">
						<i className="bx bxl-nodejs"></i>

						<div>
							<h3 className="skills_name">Node JS</h3>
						</div>
					</div>

					<div className="skills_data">
						<i className="bx bx-badge-check"></i>

						<div>
							<h3 className="skills_name">Express JS</h3>
						</div>
					</div>

					<div className="skills_data">
						<i className="bx bxl-mongodb"></i>

						<div>
							<h3 className="skills_name">Mongo DB</h3>
						</div>
					</div>

					<div className="skills_data">
						<i className="bx bx-badge-check"></i>

						<div>
							<h3 className="skills_name">Mongoose</h3>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Backend;
